module.exports = __webpack_public_path__ + "static/img/cmi_back.48bd891d.png";